import * as React from "react"
import { CloseIcon, KeyboardArrowDownIcon } from "@design/icons/material-symbols"
import { Avatar, AvatarBadge, AvatarGroup } from "@design/ui/avatar"
import { Input } from "@design/ui/input"

export interface ModalBXsU9PJPGdHkA5xZcxCesE1991130027Wiring {
  modalHeaderContent?: React.ReactNode
  close: React.ComponentProps<typeof CloseIcon>
  modalContent?: React.ReactNode
  input?: Omit<React.ComponentProps<typeof Input>, "type" | "placeholder">
  selectShowIcon?: boolean
  selectPlaceholder?: string
  iconCaretDown?: React.ComponentProps<typeof KeyboardArrowDownIcon>
  avatarGroup?: Omit<React.ComponentProps<typeof AvatarGroup>, "data-size" | "children">
  avatarGroupSlot?: React.ReactNode
  avatar?: Omit<React.ComponentProps<typeof Avatar>, "size" | "data-variant" | "children">
  avatarFallbackText?: string
  avatarShowBadge?: boolean
  avatarBadge?: Omit<React.ComponentProps<typeof AvatarBadge>, "data-type" | "children">
}

export const ModalBXsU9PJPGdHkA5xZcxCesE1991130027Context = React.createContext<ModalBXsU9PJPGdHkA5xZcxCesE1991130027Wiring | null>(null)

export function useWiring(): ModalBXsU9PJPGdHkA5xZcxCesE1991130027Wiring {
  const wiring = React.useContext(ModalBXsU9PJPGdHkA5xZcxCesE1991130027Context)
  if (wiring === null) {
    throw new Error("ModalBXsU9PJPGdHkA5xZcxCesE1991130027Screen: render inside <ModalBXsU9PJPGdHkA5xZcxCesE1991130027Context.Provider>")
  }
  return wiring
}
